import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

const RootContainer = styled.div`
	> div {
		clip-path: url(#myPath)
	};
`

const Mask = () =>
	<svg width="0" height='0'>
		<clipPath
			id='myPath'
			clipPathUnits="objectBoundingBox">
			<path
				d="M0.265385 0.938733C0.108495 1.03664 -0.0782996 0.559621 0.0344718 0.29172C0.130498 0.0635984 0.304758 -0.0472748 0.446116 0.0190154C0.527513 0.0571954 0.698178 0.106575 0.784536 0.0982829C1.03052 0.0746619 1.08263 0.8544 0.853192 0.972801C0.635679 1.08505 0.479926 0.804855 0.265385 0.938733Z"/>
		</clipPath>
	</svg>


const MaskedImage = ({className, children}) => <RootContainer className={className}>
	<Mask/>
	{children}
</RootContainer>

MaskedImage.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node.isRequired,
}

MaskedImage.defaultProps = {
	className: '',
}

export default MaskedImage
